import React from 'react';
import { Box, Typography, Paper, Chip } from '@mui/material';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const SAMPLE_GUIDES = [
  { title: 'Graduate School Application', category: 'Education', description: 'Step-by-step process for applying to graduate programs.' },
  { title: 'Business License Application', category: 'Government', description: 'Apply for a new business license in your municipality.' },
  { title: 'FOIA Request', category: 'Government', description: 'Submit a Freedom of Information Act request to a federal agency.' },
  { title: 'Grant Proposal Submission', category: 'Education', description: 'Prepare and submit a research grant proposal.' },
  { title: 'Passport Renewal', category: 'Government', description: 'Renew your U.S. passport by mail or in person.' },
  { title: 'Vendor Onboarding', category: 'Business', description: 'Complete vendor registration and compliance requirements.' },
];

const CATEGORY_COLORS: Record<string, string> = {
  Education: '#E8F5E9',
  Government: '#FFF7ED',
  Business: '#EFF6FF',
};

export default function PreviewLibraryPage() {
  useDocumentTitle('Library — apply pub');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 6, px: 2, pb: 8 }}>
      <Typography
        sx={{
          color: '#9CA3AF',
          fontSize: 15,
          mb: 4,
          textAlign: 'center',
        }}
      >
        Browse process templates and guides.
      </Typography>

      <Box sx={{ width: '100%', maxWidth: 720, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {SAMPLE_GUIDES.map((guide, idx) => (
          <Paper
            key={idx}
            elevation={0}
            sx={{
              border: '1px solid #E0D8D0',
              borderRadius: 2,
              px: 3,
              py: 2,
              bgcolor: '#FFFFFF',
              cursor: 'pointer',
              transition: 'border-color 0.15s ease',
              '&:hover': { borderColor: '#10B981' },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
              <Typography sx={{ fontSize: 15, fontWeight: 500, color: '#1A1A1A' }}>
                {guide.title}
              </Typography>
              <Chip
                label={guide.category}
                size="small"
                sx={{
                  height: 20,
                  fontSize: 11,
                  bgcolor: CATEGORY_COLORS[guide.category] ?? '#F3F4F6',
                  color: '#6B7280',
                }}
              />
            </Box>
            <Typography sx={{ fontSize: 13, color: '#9CA3AF' }}>
              {guide.description}
            </Typography>
          </Paper>
        ))}
      </Box>
    </Box>
  );
}
